import React from "react";
import { Row, Container } from "reactstrap";

const Footer = () => {
  return (
    <Container>
      <Row className="footer">&copy; 2018 Inclusive Labs Ltd.</Row>
    </Container>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/index.js